import * as React from "react";

import "./office-multi-select.scss";

import {SearchableMultiSelect} from "./searchable-multi-select";

import {cs}                    from "../../react/chain-services";
import {consumeContext}        from "../../react/context";
import {sortMulti}             from "../../utils/collections";
import {chain}                 from "../../utils/fs";

export const OfficeMultiSelect = ({branchList, displayList=true, selectedBranches}) => cs(
    consumeContext("userLevels"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ({isInternalUser}) => (
        <div className="office-select-4t2">
            {SearchableMultiSelect<any>({
                getSublabel: (branch) => <>
                    <div>
                        {[
                            branch.branchAddress1,
                            branch.branchAddress2,
                            branch.branchCity,
                            branch.branchState,
                            branch.branchZip,
                        ].filter(Boolean).join(", ")}
                    </div>
                    <div
                        xd-qa-type="dropdown_item"
                        xd-qa-name="Sub label"
                    >
                        {branch.branchLinkId} {isInternalUser && `| Internal ID: ${branch.idBranch}`}
                    </div>
                </>,
                list: chain(
                    branchList ?? [],
                    (_) => sortMulti(_, [
                        (branch) => branch["branchName"]?.toLowerCase(),
                    ]),
                ),
                loading: !branchList,
                placeholder: "Select Office(s)",
                getLabel: (branch) => branch.branchName || branch.branchLinkId,
                mapSearchAsItemFilter: (search:string) => {
                    const searchLowercase = search.toLowerCase();
                    return (branch) => (isInternalUser && branch.idBranch.includes(searchLowercase)) ||
                        [
                            "branchName",
                            "branchLinkId",
                            "branchAddress1",
                            "branchAddress2",
                            "branchCity",
                            "branchState",
                            "branchZip",
                        ].some(field => branch[field].toLowerCase().includes(searchLowercase));
                },
                onSelect: async (branch) => {
                    selectedBranches.change((branches) => [
                        ...branches,
                        branch,
                    ]);
                },
                onSelectAll: async () => {
                    selectedBranches.change((branches) => branches.length === 0 ? branchList : []);
                },
                onRemove: async (branch) => {
                    selectedBranches.change((branches) => branches.filter((b) => b.idBranch !== branch.idBranch));
                },
                isSelected: (branch) => selectedBranches.value.some(v => v.idBranch === branch.idBranch),
                getXdQaName: (branch) => branch.idBranch,

                className: "office",
                searchLabel: "Search an Office",
                xdQaName: "Office",
                scrollCloses: false,
                displayList,
            })}

            {displayList && selectedBranches.value?.length > 0 && (
                <div className="clear-selection">
                    <a
                        xd-qa-type="button"
                        xd-qa-name="Clear Selection"
                        onClick={() => {
                            selectedBranches.onChange([]);
                            close();
                        }}
                    >
                        Clear ({selectedBranches.value.length})
                    </a>
                </div>
            )}
        </div>
    ),
);